
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 15.5c1.105-.739 1.36-1.65 1-2.5-.345-.813-2.889-1.556-2.333-2.667.555-1.11 1.836.317 2.777-.555-.085-1.58-.306-2.945.357-4.432C7.769 3.11 9.778 2 12 2s4.23 1.111 5.2 3.346c.662 1.487.44 2.852.356 4.432.941.872 2.222-.556 2.777.555C20.89 11.444 18.345 12.187 18 13c-.36.85-.105 1.761 1 2.5 1.672 1.117 3 .944 3 2.079 0 1.088-2.424 1.332-3 1.421l-.7.933a.986.986 0 01-.8.396c-1.26-.017-1.678-.065-2.722.56C13.923 21.4 13.064 22 12 22s-1.923-.6-2.778-1.111c-1.044-.625-1.463-.577-2.721-.56a.986.986 0 01-.801-.396L5 19c-.576-.089-3-.333-3-1.421 0-1.135 1.328-.962 3-2.079z"}})])
          )
        }
      }
    